export const panelMinWidth = 264;
export const RESIZE_BAR_WIDTH = 14;

export const panelNames = {
  OUTLINE: 'genericOutlinesPanel',
};